// components/CarouselSlide.js – Bild mit Bildunterschrift für die Karussells der Startseite.
// Eine Fassung für alle Bildschirmgrößen (Schriftgrößen in custom.css), damit keine Überschriften doppelt im HTML stehen.
import React from "react";
import Image from "react-bootstrap/Image";

// Props: image (importiertes Bild), title/description (Bildunterschrift), alt (Bildbeschreibung).
// width/height = Pixelmaße der Bilddatei: Der Browser reserviert damit vor dem Laden den Platz (kein Layout-Sprung).
function CarouselSlide({ image, width, height, title, description, alt }) {
  return (
    <div className="d-flex flex-column align-items-center">
      <Image src={image} width={width} height={height} alt={alt} className="w-100 img-fluid" loading="lazy" decoding="async" />
      <div className="ff-slide__caption w-100 text-center text-white">
        <h3 className="ff-slide__title">{title}</h3>
        <p className="ff-slide__text">{description}</p>
      </div>
    </div>
  );
}

export default CarouselSlide;
